import { interpolateContentToJSX, InterpolateEntry } from '../../helpers';
import { useContent } from '../../hooks/use-content';
import { usePageScroller } from '../../hooks/use-page-scroller';

interface TermsOfUseForManufacturerServicesSubPageProps {
  page: string;
  interpolateContentEntries?: InterpolateEntry[];
}

export const TermsOfUseForManufacturerServicesSubPage = ({
  page,
  interpolateContentEntries,
}: TermsOfUseForManufacturerServicesSubPageProps) => {
  const content = useContent();
  const contentKeyPage = content.t(page);

  usePageScroller(contentKeyPage);

  if (interpolateContentEntries) {
    const jsxContent: JSX.Element[] = interpolateContentToJSX(contentKeyPage, interpolateContentEntries);
    return { ...jsxContent };
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: contentKeyPage,
      }}
    />
  );
};
